import { render, staticRenderFns } from "./SQLConnectionDetails.vue?vue&type=template&id=064e254f&"
import script from "./SQLConnectionDetails.vue?vue&type=script&lang=ts&"
export * from "./SQLConnectionDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports